export default __webpack_public_path__ + "static/media/imgVideo.82bbed46.jpg";